$("body").on("click", ".js-dealer__open-popup a", function(){    
    var $block = $(this).closest('.dealer'),
        $content = $("<div>");

        $content.append($block[0].cloneNode(true));

        $block.next(".dealer__offices").find(".dealer").each(function(){
        $content.append(this.cloneNode(true));
    });

        $content.find(".js-dealer__open-popup").remove();
    Popup.content($content.html());
    Popup.open();
});